import { categoryTone, RiskLegendItem } from './sentiment';
import type { CategoryScore } from '../types';

const CATEGORY_LABELS: Record<string, string> = {
  financial_fraud: 'Financial Fraud',
  hate_communal:   'Hate & Communal',
  adult:           'Adult Content',
  violence:        'Violence',
  political:       'Political',
  substance:       'Substance',
  misinformation:  'Misinformation',
  ip_legal:        'IP & Legal',
};

/** Figma "Safety / Risk Breakdown — Redesign" (node 1741:55608). */
export function RiskBreakdownCard({
  scores,
  channelStats,
}: {
  scores: CategoryScore[];
  channelStats?: { scanned: number; last12Months: number; analyzed: number; isInstagram: boolean };
}) {
  const sorted = [...scores].sort((a, b) => a.score - b.score);
  return (
    <div style={{ background: '#ffffff', border: '1px solid #E5E5E5', borderRadius: 16, padding: 24 }}>
      <div style={{ fontSize: 20, fontWeight: 500, color: '#171717', marginBottom: 18 }}>
        Safety / Risk Breakdown
      </div>

      {channelStats && (
        <div style={{
          background: '#F5F5F5', borderRadius: 10, padding: '12px 16px',
          display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 18,
        }}>
          <span style={{ fontSize: 12, fontWeight: 500, color: '#737373', textTransform: 'uppercase', letterSpacing: 0.4 }}>
            Coverage
          </span>
          <span style={{ fontSize: 14, fontWeight: 400, color: '#404040' }}>
            Scanned {channelStats.scanned} {channelStats.isInstagram ? 'posts' : 'videos'}
            {' · '}Last 12 months: {channelStats.last12Months}
            {' · '}Deep-analyzed {channelStats.analyzed}
          </span>
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
        <span style={{ fontSize: 12, fontWeight: 500, color: '#737373', textTransform: 'uppercase', letterSpacing: 0.4 }}>
          Risk Breakdown
        </span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <RiskLegendItem color="#059669" label="Safe" />
          <RiskLegendItem color="#D97706" label="Caution" />
          <RiskLegendItem color="#DC2626" label="Risk" />
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {sorted.map((cs) => {
          const tone = categoryTone(cs.score);
          const label = CATEGORY_LABELS[cs.category] ?? cs.category;
          return (
            <div key={cs.category} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ width: 9, height: 9, borderRadius: '50%', background: tone.dot, flexShrink: 0 }} />
              <span style={{
                width: 210, flexShrink: 0, fontSize: 14, fontWeight: 500, color: '#171717',
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
              }}>
                {label}
              </span>
              <div style={{ flex: 1, height: 11, background: '#E5E5E5', borderRadius: 999, overflow: 'hidden' }}>
                <div style={{ width: `${cs.score}%`, height: '100%', background: tone.bar, borderRadius: 999 }} />
              </div>
              <span style={{ width: 30, textAlign: 'right', fontSize: 16, fontWeight: 600, color: tone.text, flexShrink: 0 }}>
                {cs.score}
              </span>
              <span style={{
                flexShrink: 0, padding: '4px 10px', borderRadius: 999,
                background: '#F5F5F5', border: '1px solid #E5E5E5',
                fontSize: 14, fontWeight: 500, color: '#737373', whiteSpace: 'nowrap',
              }}>
                {cs.signal_count > 0 ? `${cs.signal_count} signal${cs.signal_count !== 1 ? 's' : ''}` : 'No signals'}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
